import React, { memo } from 'react'
import { Switch } from 'react-router-dom'
import { Redirect } from '@coachmate/router'
import { AppHeader } from '@coachmate/app'

export const AppLayout = memo(() => (
  <div className="h-full pt-20">
    <AppHeader />
    <Switch>
      <Redirect to="/download" />
    </Switch>
  </div>
))
